module.exports = __webpack_public_path__ + "img/Symptom List.ff7295b.png";